import { render } from "./GroupTable.vue?vue&type=template&id=0ff1685c"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"

import "./GroupTable.vue?vue&type=style&index=0&id=0ff1685c&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn-administrativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__